import React, { Component } from 'react';
import { Modal, Button, Input, Icon, message, Select } from 'antd';
import { Fragment } from 'react';
import { ExclamationCircleFilled } from '@ant-design/icons';

import { DepositModalWrapper, TitleWrapper } from './style'
import Coins from '../../components/Coins';
import { getNetworkLabelByKey } from '../../common/utils';

const { Option } = Select;

const getWalletsByCurrnecy = (currency, wallets) => {
	return wallets.filter((wallet) => wallet.currency === currency);
};

const getWalletByNetwork = (network, networks, currnecyWallets) => {
	let wallet;
	if (!networks && currnecyWallets.length === 1) {
		wallet = currnecyWallets[0];
	} else if (network) {
		wallet = currnecyWallets.find((wallet) => wallet.network === network);
	}

	return wallet ? wallet['address'] : '';
};

export const getWallet = (currnecy, network, wallets, networks) => {
	return getWalletByNetwork(
		network,
		networks,
		getWalletsByCurrnecy(currnecy, wallets)
	);
};

class XhtDeposit extends Component {
	constructor() {
		super()
		this.state = {
			selectedItem: ""
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (JSON.stringify(this.props.networks) !== JSON.stringify(prevProps.networks)) {
			if (this.props.networks && this.props.networks.length === 1) {
				this.setState({ selectedItem: this.props.networks[0] });
			} else {
				this.setState({ selectedItem: '' });
			}
			
		}
	}

	copy = (e) => {
		const copyText = e.input;
		/* Select the text field */
		copyText.select();
		copyText.setSelectionRange(0, 99999); /*For mobile devices*/

		/* Copy the text inside the text field */
		document.execCommand('copy');
		message.success('Copied!');
	};

	handleSelect = (selectedItem) => {
		this.setState({ selectedItem });
	};

	handleCancel = () => {
		this.setState({ selectedItem: '' });
		this.props.onCancel();
	};

	renderTitle = () => {
		const { symbol, fullname } = this.props;
		return (
			<TitleWrapper>
				<div className="title-wrapper">
					<div className="title">Deposit</div>
					<Coins type={symbol.toLowerCase()} small={true} />{fullname}
				</div>
			</TitleWrapper>
		)
	};

	render() {
		const {
			visible,
			onOk,
			symbol = 'xht',
			wallet = [],
			fullname = '',
			balance = {},
			networks = ''
		} = this.props;
		const { selectedItem } = this.state;
		let address = getWallet(symbol, selectedItem, wallet, networks);
		let srcAddress = address || "";
		let destinationTag = '';
		let destinationLabel = 'Destination tag:';
		if (symbol === 'xrp' || symbol === 'xlm') {
			const temp = address.split(':');
			srcAddress = temp[0] ? temp[0] : address;
			destinationTag = temp[1] ? temp[1] : '';
		}
		if (symbol === 'xlm') {
			destinationLabel = 'Memo:'
		}
		let coinBalance = balance[`${symbol.toLowerCase()}_available`]
		return (
			<Modal
				visible={visible}
				// title={`Deposit ${symbol.toUpperCase()}`}
				title={this.renderTitle()}
				onOk={onOk}
				onCancel={this.handleCancel}
				footer={false}
			>
				<DepositModalWrapper>
					<div className='text-content'>
						{`Available ${fullname} Balance: ${coinBalance} ${symbol.toUpperCase()}`}
					</div>
					{networks && networks.length
						? <div className="select-wrapper">
							<div className='title-content'>Network</div>
							<div>
								<Select
									placeholder="Select a network"
									value={selectedItem || undefined}
									onChange={this.handleSelect}
								>
									{networks.map((network, index) => (
										<Option key={index} value={network}>
											{getNetworkLabelByKey(network)}
										</Option>
									))}
								</Select>
							</div>
							<div className="warning-wrapper">
								<ExclamationCircleFilled />
								Make sure the network selected is a compatible with the senders wallet network
							</div>
						</div>
						: null
					}
					{srcAddress !== ""
						?
						<div>
							<p style={{ paddingTop: '12px' }}>
								<b>{`${symbol.toUpperCase()} Deposit Address:`}</b>
							</p>
							<p>
								<Input
									ref={(el) => {
										this.apiKey = el;
									}}
									value={srcAddress}
									readOnly
									addonAfter={
										<Icon
											type="copy"
											onClick={() => this.copy(this.apiKey)}
										/>
									}
								/>
							</p>
							{destinationTag
								? <Fragment>
									<p style={{ paddingTop: '12px' }}>
										<b>{destinationLabel}</b>
									</p>
									<p>
										<Input
											ref={(el) => {
												this.destinationTag = el;
											}}
											value={destinationTag}
											readOnly
											addonAfter={
												<Icon
													type="copy"
													onClick={() => this.copy(this.destinationTag)}
												/>
											}
										/>
									</p>
								</Fragment>
								: null
							}
						</div>
						: null
					}
					{(!address && !networks) || (networks && networks.length && selectedItem && !address)
						? <div className="btn-wrapper">
							<Button
								type="primary"
								onClick={() => this.props.getCryptoAddress(symbol, selectedItem)}
							>
								Generate Address
								</Button>
						</div>
						: null
					}
				</DepositModalWrapper>
			</Modal>
		);
	}
}

export default XhtDeposit;
